module.exports = __webpack_public_path__ + "static/media/portfolio2.a287dff1.webp";